import React from "react";

export const Paragraph = ({ children, classNames }) => {
    return (
        <p
            className={`font-normal text-[14px] lg:text-[16px] xl:text-[18px]  leading-[22px] lg:leading-[26px] text-gray ${classNames}`}
        >
            {children}
        </p>
    );
};
